if (!window.variantCardAddToCartInitialized) {
window.variantCardAddToCartInitialized = true;
if (!document.getElementById('variant-card-quantity-styles')) {
const quantityStyles = document.createElement('style');
quantityStyles.id = 'variant-card-quantity-styles';
quantityStyles.textContent = `
.variant-card-option-value {
display: contents;
}
.variant-card-option-value[hidden],
.variant-card-size-button[hidden],
.variant-card-size-select option[hidden],
.js-variant-card-option-group[hidden] {
display: none !important;
}
.card__main-image[hidden] {
display: none !important;
}
.variant-card-color-options {
min-width: 0;
}
.variant-card-color-options__label {
display: block;
width: 100%;
margin: 0 0 3px;
padding: 0;
color: inherit;
font-size: 1.35rem;
font-weight: 700;
line-height: 1.2;
}
.variant-card-size-options {
position: relative;
z-index: 2;
min-width: 0;
margin-right: 0;
margin-left: 0;
padding-right: 0;
padding-left: 0;
border-right: 0;
border-bottom: 0;
border-left: 0;
}
.variant-card-size-options__label {
display: block;
width: 100%;
margin: 0 0 8px;
padding: 0;
color: inherit;
font-size: 1.35rem;
font-weight: 700;
line-height: 1.2;
}
.variant-card-size-options__buttons {
position: relative;
z-index: 2;
display: flex;
flex-wrap: wrap;
gap: 8px;
min-width: 0;
}
.variant-card-size-options__select-wrap {
position: relative;
z-index: 2;
width: 100%;
}
.variant-card-size-options__select-wrap--mobile {
display: none;
}
@media (max-width: 768px) {
.variant-card-size-options__select-wrap--mobile {
display: block;
}
.variant-card-size-options__buttons--desktop {
display: none;
}
}
.variant-card-size-select {
display: block;
width: 100%;
min-height: 45px;
margin: 0;
padding: 10px 42px 10px 13px;
border: 1px solid rgba(127, 127, 127, 0.38);
border-color: color-mix(in srgb, currentColor 28%, transparent);
border-radius: 7px;
background-color: transparent;
color: inherit;
font: inherit;
font-size: 1.5rem;
font-weight: 700;
line-height: 1.2;
cursor: pointer;
}
.variant-card-size-select:hover,
.variant-card-size-select:focus-visible {
border-color: currentColor;
}
.variant-card-size-select:focus-visible {
outline: 2px solid currentColor;
outline-offset: 2px;
}
.variant-card-size-button {
position: relative;
z-index: 2;
display: inline-flex;
align-items: center;
justify-content: center;
min-width: 46px;
min-height: 42px;
margin: 0;
padding: 9px 14px;
border: 1px solid rgba(127, 127, 127, 0.38);
border-color: color-mix(in srgb, currentColor 28%, transparent);
border-radius: 7px;
background: transparent;
color: inherit;
font: inherit;
font-size: 1.1rem;
font-weight: 650;
line-height: 1;
cursor: pointer;
transition: border-color 150ms ease, background-color 150ms ease, opacity 150ms ease;
}
@media (min-width: 769px) {
.variant-card-size-button {
font-size: 1.25rem;
}
}
.variant-card-size-button:hover:not(:disabled),
.variant-card-size-button:focus-visible {
border-color: currentColor;
}
.variant-card-size-button:focus-visible {
outline: 2px solid currentColor;
outline-offset: 2px;
}
.variant-card-size-button.is-selected,
.variant-card-size-button[aria-pressed="true"] {
border-width: 2px;
border-color: currentColor;
background: color-mix(in srgb, currentColor 14%, transparent);
color: inherit;
font-weight: 800;
}
.variant-card-size-button.is-sold-out {
text-decoration: line-through;
opacity: 0.55;
}
.variant-card-size-button:disabled {
cursor: not-allowed;
opacity: 0.28;
}
.variant-card-vendor-line {
display: flex;
align-items: center;
flex-wrap: wrap;
gap: 6px 9px;
width: 100%;
}
.variant-card-vendor-name {
min-width: 0;
}
.variant-card-title-prefix {
color: inherit;
font: inherit;
font-weight: inherit;
letter-spacing: inherit;
}
.variant-card-title-prefix[hidden],
.variant-card-sku-below-title[hidden] {
display: none !important;
}
.variant-card-sku-below-title {
display: inline-flex;
align-items: center;
gap: 5px;
max-width: 100%;
min-width: 0;
padding: 0;
border: 0;
border-radius: 0;
background: transparent;
color: #000;
font-family: inherit;
font-weight: inherit;
font-size: 1.29rem;
line-height: 1.4;
letter-spacing: inherit;
vertical-align: middle;
}
.variant-card-sku-standalone {
width: fit-content;
margin-top: 10px;
margin-bottom: 4px;
}
.variant-card-sku-below-title__label {
flex: 0 0 auto;
font-size: 1em;
font-weight: inherit;
letter-spacing: inherit;
}
.variant-card-sku-below-title__value {
min-width: 0;
overflow: hidden;
font-weight: inherit;
letter-spacing: inherit;
text-overflow: ellipsis;
white-space: nowrap;
}
.variant-card-purchase-row {
--variant-card-control-height: 44px;
display: grid;
grid-template-columns: minmax(108px, 126px) minmax(0, 1fr);
align-items: stretch;
gap: 10px;
width: 100%;
max-width: 100%;
min-width: 0;
min-height: var(--variant-card-control-height);
box-sizing: border-box;
}
.variant-card-purchase-row[hidden],
.variant-card-quantity[hidden],
.variant-card-notify[hidden] {
display: none !important;
}
.variant-card-notify {
width: 100%;
max-width: 100%;
min-width: 0;
min-height: var(--variant-card-control-height);
padding: 9px 12px;
box-sizing: border-box;
display: flex;
align-items: center;
justify-content: center;
border-color: var(--display-cases-red, #b40c1c);
color: var(--display-cases-red, #b40c1c);
font-weight: 700;
line-height: 1.15;
text-align: center;
white-space: normal;
}
.variant-card-notify:hover {
background: var(--display-cases-red, #b40c1c);
border-color: var(--display-cases-red, #b40c1c);
color: #fff;
}
.variant-card-purchase-row .js-variant-card-atc {
width: 100%;
max-width: 100%;
min-width: 0;
min-height: var(--variant-card-control-height);
height: 100%;
padding-right: 10px;
padding-left: 10px;
box-sizing: border-box;
display: flex;
align-items: center;
justify-content: center;
white-space: normal !important;
overflow: hidden;
}
.variant-card-purchase-row .js-variant-card-atc .quick-add-btn-text {
display: block;
width: 100%;
min-width: 0;
overflow: visible;
text-align: center;
text-overflow: clip;
white-space: normal !important;
overflow-wrap: anywhere;
word-break: normal;
}
.variant-card-purchase-row.is-out-of-stock {
grid-template-columns: minmax(0, 1fr);
gap: 0;
}
.variant-card-purchase-row.is-out-of-stock .js-variant-card-atc {
flex: 1 1 100%;
width: 100%;
max-width: none;
opacity: 1;
cursor: not-allowed;
}
.variant-card-purchase-row.is-out-of-stock .quick-add-btn-icon {
display: none;
}
.variant-card-quantity {
width: 100%;
min-width: 0;
height: 100%;
margin: 0;
}
.variant-card-quantity__label {
position: absolute !important;
width: 1px !important;
height: 1px !important;
padding: 0 !important;
margin: -1px !important;
overflow: hidden !important;
clip: rect(0, 0, 0, 0) !important;
white-space: nowrap !important;
border: 0 !important;
}
.variant-card-quantity__stepper {
display: grid;
grid-template-columns: repeat(3, minmax(0, 1fr));
width: 100%;
height: 100%;
min-height: var(--variant-card-control-height);
overflow: hidden;
border: 1px solid rgba(127, 127, 127, 0.35);
border-color: color-mix(in srgb, currentColor 24%, transparent);
border-radius: 9px;
background: var(--bg-color, #fff);
}
.variant-card-quantity__button,
.variant-card-quantity__input {
width: 100%;
min-width: 0;
height: 100%;
min-height: 0;
margin: 0;
padding: 0;
border: 0;
border-radius: 0;
background: transparent;
color: inherit;
font: inherit;
}
.variant-card-quantity__button {
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
font-size: 1.25rem;
font-weight: 600;
line-height: 1;
transition: background-color 150ms ease, opacity 150ms ease;
}
.variant-card-quantity__button:hover:not(:disabled) {
background: rgba(127, 127, 127, 0.12);
background: color-mix(in srgb, currentColor 9%, transparent);
}
.variant-card-quantity__button:focus-visible,
.variant-card-quantity__input:focus-visible {
position: relative;
z-index: 1;
outline: 2px solid currentColor;
outline-offset: -2px;
}
.variant-card-quantity__button:disabled {
cursor: not-allowed;
opacity: 0.32;
}
.variant-card-quantity__input {
border-right: 1px solid rgba(127, 127, 127, 0.25);
border-left: 1px solid rgba(127, 127, 127, 0.25);
border-color: color-mix(in srgb, currentColor 18%, transparent);
text-align: center;
font-weight: 700;
appearance: textfield;
-moz-appearance: textfield;
}
.variant-card-quantity__input::-webkit-inner-spin-button,
.variant-card-quantity__input::-webkit-outer-spin-button {
margin: 0;
appearance: none;
-webkit-appearance: none;
}
@media (max-width: 749px) {
.variant-card-vendor-line {
gap: 5px 7px;
}
.variant-card-sku-below-title {
padding: 0;
font-size: 1.17rem;
}
.variant-card-purchase-row {
--variant-card-control-height: 42px;
grid-template-columns: minmax(64px, 72px) minmax(0, 1fr);
gap: 5px;
}
.variant-card-quantity__stepper {
border-radius: 8px;
}
.variant-card-quantity__button,
.variant-card-quantity__input {
height: 100%;
min-height: 0;
}
.variant-card-quantity__button {
font-size: 1rem;
}
.variant-card-purchase-row .js-variant-card-atc {
min-height: var(--variant-card-control-height);
height: 100%;
padding: 4px 5px;
font-size: clamp(0.67rem, 2.7vw, 0.82rem);
line-height: 1.08;
letter-spacing: -0.02em;
}
.variant-card-purchase-row:not(.is-out-of-stock) .js-variant-card-atc .quick-add-btn-icon {
display: none !important;
}
}
@media (max-width: 374px) {
.variant-card-purchase-row {
grid-template-columns: 60px minmax(0, 1fr);
gap: 4px;
}
.variant-card-purchase-row .js-variant-card-atc {
padding-right: 2px;
padding-left: 2px;
font-size: 0.64rem;
}
}
`;
document.head.appendChild(quantityStyles);
}
const getVariantData = (card) => {
if (card._variantCardData) return card._variantCardData;
const dataElement = card.querySelector('.js-variant-card-data');
if (!dataElement) return new Map();
try {
const variants = JSON.parse(dataElement.textContent);
card._variantCardData = new Map(
variants.map((variant) => [String(variant.id), variant])
);
} catch (error) {
card._variantCardData = new Map();
}
return card._variantCardData;
};
const getVariantList = (card) => Array.from(getVariantData(card).values());
const normalizeOptionValue = (value) => {
const resolvedValue = value && typeof value === 'object'
? (value.name ?? value.value ?? '')
: value;
return String(resolvedValue ?? '').trim().toLocaleLowerCase();
};
const getOptionCount = (card) => {
const declaredCount = Number.parseInt(card.dataset.optionCount || '', 10);
if (Number.isFinite(declaredCount) && declaredCount > 0) return declaredCount;
const firstVariant = getVariantList(card)[0];
return Array.isArray(firstVariant?.options) ? firstVariant.options.length : 0;
};
const getRenderedOptionPositions = (card) => Array.from(new Set(
Array.from(card.querySelectorAll(
'.js-variant-card-option-value[data-option-position], ' +
'.js-variant-card-size-button[data-option-position], ' +
'.js-variant-card-size-select[data-option-position]'
)).map((element) => Number.parseInt(element.dataset.optionPosition || '', 10))
.filter(Number.isFinite)
));
const getPrimaryOptionPosition = (card) => {
const positions = getRenderedOptionPositions(card);
return positions.length ? Math.min(...positions) : 1;
};
const getOptionElement = (element) => element?.closest?.(
'.js-variant-card-option-value, .js-variant-card-size-button, .js-variant-card-size-select'
) || null;
const elementLooksSelected = (element) => {
if (!element) return false;
if (element.dataset.selected === 'true') return true;
if (element.getAttribute('aria-pressed') === 'true') return true;
if (element.getAttribute('aria-checked') === 'true') return true;
if (element.matches('input:checked, .is-selected, .selected, .active')) return true;
return Boolean(element.querySelector(
'input:checked, [aria-checked="true"], [aria-pressed="true"], [data-selected="true"], .is-selected, .selected, .active'
));
};
const syncSizeOptionControls = (card, position, value) => {
const normalizedValue = normalizeOptionValue(value);
card.querySelectorAll(
`.js-variant-card-size-button[data-option-position="${position}"]`
).forEach((button) => {
const selected = normalizeOptionValue(button.dataset.optionValue) === normalizedValue;
button.dataset.selected = selected ? 'true' : 'false';
button.classList.toggle('is-selected', selected);
button.setAttribute('aria-pressed', selected ? 'true' : 'false');
});
card.querySelectorAll(
`.js-variant-card-size-select[data-option-position="${position}"]`
).forEach((select) => {
const matchingOption = Array.from(select.options).find(
(option) => normalizeOptionValue(option.value) === normalizedValue
);
if (!matchingOption) return;
select.value = matchingOption.value;
select.dataset.optionValue = matchingOption.value;
select.dataset.selected = 'true';
select.classList.add('is-selected');
});
};
const clearOptionPosition = (card, position, except = null) => {
card.querySelectorAll(
`.js-variant-card-option-value[data-option-position="${position}"], ` +
`.js-variant-card-size-button[data-option-position="${position}"], ` +
`.js-variant-card-size-select[data-option-position="${position}"]`
).forEach((element) => {
if (element === except) return;
element.dataset.selected = 'false';
element.classList.remove('is-selected');
element.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
input.checked = false;
});
if (element.matches('.js-variant-card-size-button')) {
element.setAttribute('aria-pressed', 'false');
}
});
};
const selectOptionElement = (card, element) => {
const optionElement = getOptionElement(element);
if (!optionElement || optionElement.disabled) return null;
const position = Number.parseInt(optionElement.dataset.optionPosition || '', 10);
if (!Number.isFinite(position)) return null;
clearOptionPosition(card, position, optionElement);
optionElement.dataset.selected = 'true';
optionElement.classList.add('is-selected');
if (optionElement.matches('.js-variant-card-size-button')) {
optionElement.setAttribute('aria-pressed', 'true');
}
if (optionElement.matches('.js-variant-card-size-button, .js-variant-card-size-select')) {
syncSizeOptionControls(card, position, optionElement.dataset.optionValue);
}
return optionElement;
};
const selectInitialVariantOptions = (card) => {
const initialVariantId = String(card.dataset.initialVariantId || '');
if (!initialVariantId) return;
const requestedVariant = getVariantData(card).get(initialVariantId);
if (!requestedVariant || !Array.isArray(requestedVariant.options)) return;
const primaryPosition = getPrimaryOptionPosition(card);
const requestedPrimaryValue = requestedVariant.options[primaryPosition - 1];
const initialVariant = requestedVariant.available
? requestedVariant
: getVariantList(card).find((variant) => (
variant.available &&
Array.isArray(variant.options) &&
normalizeOptionValue(variant.options[primaryPosition - 1]) === normalizeOptionValue(requestedPrimaryValue)
)) || requestedVariant;
initialVariant.options.forEach((value, index) => {
const position = index + 1;
const optionElement = Array.from(card.querySelectorAll(
`.js-variant-card-option-value[data-option-position="${position}"], ` +
`.js-variant-card-size-button[data-option-position="${position}"], ` +
`.js-variant-card-size-select[data-option-position="${position}"]`
)).find((element) => (
normalizeOptionValue(element.dataset.optionValue) === normalizeOptionValue(value)
));
if (!optionElement) return;
selectOptionElement(card, optionElement);
const input = optionElement.matches('input[type="radio"]')
? optionElement
: optionElement.querySelector('input[type="radio"]');
if (input && !input.disabled) input.checked = true;
});
};
const syncThemeSelectedOptions = (card) => {
const positions = new Set();
card.querySelectorAll('.js-variant-card-option-value').forEach((element) => {
const position = element.dataset.optionPosition;
if (position) positions.add(position);
});
positions.forEach((position) => {
const elements = Array.from(card.querySelectorAll(
`.js-variant-card-option-value[data-option-position="${position}"]`
));
// Liquid can check a collection-specific color radio even when
// Shopify's option object still marks another value as selected.
// The actual checked control is authoritative.
const checkedControl = elements.find((element) => (
element.matches('input:checked') || Boolean(element.querySelector('input:checked'))
));
if (checkedControl) {
selectOptionElement(card, checkedControl);
return;
}
const alreadySelected = elements.find((element) => element.dataset.selected === 'true');
if (alreadySelected) return;
const themeSelected = elements.find(elementLooksSelected);
if (themeSelected) selectOptionElement(card, themeSelected);
});
};
const getSelectedOptions = (card) => {
syncThemeSelectedOptions(card);
const selected = new Map();
card.querySelectorAll(
'.js-variant-card-option-value[data-selected="true"], ' +
'.js-variant-card-size-button[data-selected="true"], ' +
'.js-variant-card-size-select[data-selected="true"], ' +
'.js-variant-card-size-button[aria-pressed="true"]'
).forEach((element) => {
const position = Number.parseInt(element.dataset.optionPosition || '', 10);
const value = element.dataset.optionValue;
if (Number.isFinite(position) && value != null && !selected.has(position)) {
selected.set(position, value);
}
});
return selected;
};
const getSelectedVariant = (card) => {
const variants = getVariantList(card);
const hasVisibleOptionControls = Boolean(card.querySelector(
'.js-variant-card-option-value, .js-variant-card-size-button, .js-variant-card-size-select'
));
if (variants.length === 1 && !hasVisibleOptionControls) return variants[0];
const selected = getSelectedOptions(card);
const optionCount = getOptionCount(card);
if (!optionCount) return null;
const exactVariant = variants.find((variant) => {
if (!Array.isArray(variant.options) || variant.options.length < optionCount) return false;
return variant.options.every((value, index) => (
normalizeOptionValue(value) === normalizeOptionValue(selected.get(index + 1))
));
}) || null;
if (exactVariant) return exactVariant;
// Product cards intentionally expose only shopper-facing options such as
// Color and Size. If an administrative option (for example Style) is not
// rendered on the card, resolve the first available variant matching all
// visible selections instead of leaving the card without a variant.
const renderedPositions = new Set();
card.querySelectorAll(
'.js-variant-card-option-value[data-option-position], ' +
'.js-variant-card-size-button[data-option-position], ' +
'.js-variant-card-size-select[data-option-position]'
).forEach((element) => {
const position = Number.parseInt(element.dataset.optionPosition || '', 10);
if (Number.isFinite(position)) renderedPositions.add(position);
});
const allRenderedOptionsSelected = renderedPositions.size > 0
&& Array.from(renderedPositions).every((position) => selected.has(position));
if (!allRenderedOptionsSelected) return null;
const matchingVariants = variants.filter((variant) => (
Array.isArray(variant.options)
&& Array.from(selected).every(([position, value]) => (
normalizeOptionValue(variant.options[position - 1]) === normalizeOptionValue(value)
))
));
return matchingVariants.find((variant) => variant.available)
|| matchingVariants[0]
|| null;
};
const findOptionControlAtPosition = (card, position, value) => {
const elements = Array.from(card.querySelectorAll(
`.js-variant-card-option-value[data-option-position="${position}"], ` +
`.js-variant-card-size-button[data-option-position="${position}"], ` +
`.js-variant-card-size-select[data-option-position="${position}"]`
));
const wrapper = elements.find((element) => (
normalizeOptionValue(element.dataset.optionValue) === normalizeOptionValue(value)
));
if (!wrapper) return null;
if (wrapper.matches('.js-variant-card-size-button, .js-variant-card-size-select')) return wrapper;
return wrapper.querySelector('a, button, input, label') || wrapper;
};
const getOptionName = (card, position) => {
const control = card.querySelector(
`[data-option-position="${position}"][data-option-name]`
);
return control?.dataset.optionName || `Option ${position}`;
};
const formatOptionChanges = (changes) => {
if (changes.length === 1) return changes[0];
if (changes.length === 2) return `${changes[0]} and ${changes[1]}`;
return `${changes.slice(0, -1).join(', ')}, and ${changes[changes.length - 1]}`;
};
const getInvalidCombinationMessage = (
card,
selected,
variant,
clickedPosition,
clickedValue
) => {
const changes = [];
selected.forEach((currentValue, position) => {
if (position === clickedPosition || currentValue == null) return;
const nextValue = variant.options[position - 1];
if (nextValue == null || normalizeOptionValue(currentValue) === normalizeOptionValue(nextValue)) {
return;
}
if (!findOptionControlAtPosition(card, position, nextValue)) return;
changes.push(
`${getOptionName(card, position)} from “${currentValue}” to “${nextValue}”`
);
});
if (!changes.length) return '';
return `That exact combination isn’t offered. Choosing “${clickedValue}” for ${getOptionName(card, clickedPosition)} will also change ${formatOptionChanges(changes)}. Would you like to continue?`;
};
const restoreCardSelection = (card, selection) => {
const positions = new Set();
card.querySelectorAll(
'.js-variant-card-option-value[data-option-position], ' +
'.js-variant-card-size-button[data-option-position], ' +
'.js-variant-card-size-select[data-option-position]'
).forEach((element) => {
const position = Number.parseInt(element.dataset.optionPosition || '', 10);
if (Number.isFinite(position)) positions.add(position);
});
positions.forEach((position) => clearOptionPosition(card, position));
selection.forEach((value, position) => {
const control = findOptionControlAtPosition(card, position, value);
if (!control) return;
const optionElement = selectOptionElement(card, control);
const input = optionElement?.matches('input[type="radio"], input[type="checkbox"]')
? optionElement
: optionElement?.querySelector('input[type="radio"], input[type="checkbox"]');
if (input && !input.disabled) input.checked = true;
});
card.querySelectorAll('.js-variant-card-size-select[data-selected="false"]').forEach((select) => {
select.value = '';
select.dataset.optionValue = '';
});
syncThemeSelectedOptions(card);
};
const reconcileSelection = (card, clickedPosition, clickedValue) => {
if (!Number.isFinite(clickedPosition)) return;
const depth = card._reconcileDepth || 0;
if (depth > 4) return;
const variants = getVariantList(card);
const selected = getSelectedOptions(card);
const optionCount = getOptionCount(card);
const exactMatch = optionCount > 0 && selected.size >= optionCount
? variants.find((variant) => (
Array.isArray(variant.options) && variant.options.length >= optionCount &&
variant.options.every((value, index) => (
normalizeOptionValue(value) === normalizeOptionValue(selected.get(index + 1))
))
)) || null
: null;
const candidates = variants.filter((variant) => (
Array.isArray(variant.options) &&
normalizeOptionValue(variant.options[clickedPosition - 1]) === normalizeOptionValue(clickedValue)
));
if (!candidates.length) return;
const availableCandidates = candidates.filter((variant) => variant.available);
if (exactMatch && (exactMatch.available || availableCandidates.length === 0)) return;
const candidatePool = availableCandidates.length ? availableCandidates : candidates;
let best = null;
let bestScore = -1;
candidatePool.forEach((variant) => {
let score = 0;
selected.forEach((value, position) => {
if (position === clickedPosition) return;
if (normalizeOptionValue(variant.options[position - 1]) === normalizeOptionValue(value)) {
score += 1;
}
});
if (variant.available) score += 0.5;
if (score > bestScore) {
bestScore = score;
best = variant;
}
});
if (!best) return;
const confirmationMessage = depth === 0 && clickedPosition !== getPrimaryOptionPosition(card)
? getInvalidCombinationMessage(card, selected, best, clickedPosition, clickedValue)
: '';
if (confirmationMessage && !window.confirm(confirmationMessage)) {
restoreCardSelection(card, card._lastValidOptions || new Map());
return;
}
card._reconcileDepth = depth + 1;
try {
best.options.forEach((value, index) => {
const position = index + 1;
if (position === clickedPosition) return;
if (normalizeOptionValue(selected.get(position)) === normalizeOptionValue(value)) return;
const control = findOptionControlAtPosition(card, position, value);
if (control) control.click();
});
} finally {
card._reconcileDepth = depth;
}
};
const updateOptionAvailability = (card) => {
const variants = getVariantList(card);
const selected = getSelectedOptions(card);
const primaryPosition = getPrimaryOptionPosition(card);
// Secondary values are evaluated against every selected option that comes
// before them. Values without a purchasable matching variant stay out of
// the UI until the primary/preceding selection makes them valid.
const getMatchingVariants = (position, candidateValue) => variants.filter((variant) => (
Array.isArray(variant.options) &&
normalizeOptionValue(variant.options[position - 1]) === normalizeOptionValue(candidateValue) &&
Array.from(selected).every(([selectedPosition, selectedValue]) => (
selectedPosition >= position ||
normalizeOptionValue(variant.options[selectedPosition - 1]) === normalizeOptionValue(selectedValue)
))
));
const updateControlVisibility = (control, position, candidateValue) => {
const matchingVariants = getMatchingVariants(position, candidateValue);
const available = matchingVariants.some((variant) => variant.available);
control.dataset.available = available ? 'true' : 'false';
control.hidden = position > primaryPosition && matchingVariants.length === 0;
return available;
};
card.querySelectorAll('.js-variant-card-option-value').forEach((optionValue) => {
const position = Number.parseInt(optionValue.dataset.optionPosition || '', 10);
if (!Number.isFinite(position)) return;
updateControlVisibility(optionValue, position, optionValue.dataset.optionValue);
});
card.querySelectorAll('.js-variant-card-size-button').forEach((button) => {
const position = Number.parseInt(button.dataset.optionPosition || '', 10);
const available = updateControlVisibility(button, position, button.dataset.optionValue);
button.disabled = false;
button.removeAttribute('aria-disabled');
button.classList.toggle('is-sold-out', !available);
});
card.querySelectorAll('.js-variant-card-size-select').forEach((select) => {
const position = Number.parseInt(select.dataset.optionPosition || '', 10);
const soldOutText = select.dataset.soldOutText || 'Sold out';
Array.from(select.options).forEach((option) => {
const available = updateControlVisibility(option, position, option.value);
const optionLabel = option.dataset.optionLabel
|| option.textContent.replace(/\s+—\s+Sold out\s*$/i, '').trim();
option.dataset.optionLabel = optionLabel;
option.disabled = option.hidden;
option.textContent = available ? optionLabel : `${optionLabel} — ${soldOutText}`;
});
});
card.querySelectorAll('.js-variant-card-option-group[data-option-position]').forEach((group) => {
const position = Number.parseInt(group.dataset.optionPosition || '', 10);
if (!Number.isFinite(position) || position <= primaryPosition) {
group.hidden = false;
return;
}
const discreteControls = Array.from(group.querySelectorAll(
'.js-variant-card-option-value, .js-variant-card-size-button'
));
const selectOptions = Array.from(group.querySelectorAll(
'.js-variant-card-size-select option'
));
if (!discreteControls.length && !selectOptions.length) return;
group.hidden = !discreteControls.some((control) => !control.hidden)
&& !selectOptions.some((option) => !option.hidden);
});
};
const updateVariantLinks = (card, variant) => {
if (!variant?.id) return;
card.querySelectorAll('a.js-prod-link, a.js-variant-card-choose, a.quick-add-view-btn').forEach((link) => {
try {
const url = new URL(link.href, window.location.origin);
url.searchParams.set('variant', String(variant.id));
link.href = `${url.pathname}${url.search}${url.hash}`;
} catch (error) {
// Leave malformed or non-standard links unchanged.
}
});
};
const getColorOptionPosition = (card) => {
const colorElement = card.querySelector('.js-variant-card-option-value');
const position = Number.parseInt(colorElement?.dataset.optionPosition || '', 10);
return Number.isFinite(position) ? position : null;
};
const findImageByColorName = (card, colorValue, images) => {
const normalizeColor = (value) => normalizeOptionValue(value)
.replace(/\bgrey\b/g, 'gray')
.replace(/\baluminium\b/g, 'aluminum')
.replace(/[^a-z0-9]+/g, ' ')
.trim();
const normalizedColor = normalizeColor(colorValue);
if (!normalizedColor) return null;
const colorPosition = getColorOptionPosition(card);
const knownColors = colorPosition
? getVariantList(card)
.map((variant) => normalizeColor(variant.options[colorPosition - 1]))
.filter((value, index, values) => value && values.indexOf(value) === index)
: [normalizedColor];
if (!knownColors.includes(normalizedColor)) knownColors.push(normalizedColor);
return images.find((image) => {
const findMatchingColors = (candidate) => {
const normalizedCandidate = ` ${normalizeColor(candidate)} `;
return knownColors.filter(
(color) => normalizedCandidate.includes(` ${color} `)
);
};
let matchingColors = findMatchingColors(image.dataset.mediaAlt || image.alt);
if (!matchingColors.length) {
matchingColors = findMatchingColors(image.dataset.mediaFilename);
}
const longestMatch = matchingColors.reduce(
(length, color) => Math.max(length, color.length),
0
);
return matchingColors.includes(normalizedColor)
&& normalizedColor.length === longestMatch;
}) || null;
};
const preloadVariantImages = (card) => {
// Homepage cards retain native lazy loading until their images approach the viewport.
if (card.closest('[data-homepage-lazy-images]')) return;
card.querySelectorAll('.card__main-image[data-media-id]').forEach((image) => {
if (image.getAttribute('loading') === 'lazy') {
image.loading = 'eager';
}
if (image.getAttribute('fetchpriority') === 'low') {
image.setAttribute('fetchpriority', 'auto');
}
});
};
const updateVariantImage = (card, variant) => {
const images = Array.from(card.querySelectorAll('.card__main-image[data-media-id]'));
if (!images.length) return;
let selectedImage = null;
if (variant?.featured_media_id) {
selectedImage = images.find(
(image) => String(image.dataset.mediaId) === String(variant.featured_media_id)
) || null;
}
if (!selectedImage) {
const colorPosition = getColorOptionPosition(card);
if (colorPosition) {
const selected = getSelectedOptions(card);
const selectedColorControl = card.querySelector(
`.js-variant-card-option-value[data-option-position="${colorPosition}"][data-selected="true"]`
);
const mediaControl = selectedColorControl?.matches('[data-media-id]')
? selectedColorControl
: selectedColorControl?.querySelector('[data-media-id]');
const fallbackMediaId = mediaControl?.dataset.mediaId;
if (fallbackMediaId) {
selectedImage = images.find(
(image) => String(image.dataset.mediaId) === String(fallbackMediaId)
) || null;
}
if (!selectedImage) {
selectedImage = findImageByColorName(card, selected.get(colorPosition), images);
}
}
}
if (!selectedImage) return;
const imageSlider = card.querySelector('product-card-image-slider');
if (imageSlider) {
const mediaId = String(selectedImage.dataset.mediaId || '');
if (!mediaId) return;
const colorPosition = getColorOptionPosition(card);
const selectedColor = colorPosition ? getSelectedOptions(card).get(colorPosition) : '';
const selectNativeSlide = () => {
if (typeof imageSlider.handleSwatchChange === 'function') {
imageSlider.handleSwatchChange(null, mediaId, selectedColor);
}
};
if (customElements.get('product-card-image-slider')) {
selectNativeSlide();
} else {
customElements.whenDefined('product-card-image-slider').then(selectNativeSlide);
}
return;
}
images.forEach((image) => {
image.hidden = image !== selectedImage;
});
};
const setButtonText = (button, text) => {
const visibleText = button.querySelector('.js-variant-card-atc-text');
const accessibleText = button.querySelector('.js-variant-card-atc-accessible-text');
if (visibleText) visibleText.textContent = text;
if (accessibleText) accessibleText.textContent = text;
};
const updateVariantSelectionDisplay = (form, variant = null) => {
if (!form) return;
const card = form.closest('product-card');
const scope = card || form;
const titlePrefix = scope.querySelector('.js-variant-card-title-prefix');
const skuWrap = scope.querySelector('.js-variant-card-sku-wrap');
const skuElement = scope.querySelector('.js-variant-card-sku');
const title = variant?.title && variant.title !== 'Default Title'
? String(variant.title).trim()
: '';
const sku = variant?.sku ? String(variant.sku).trim() : '';
if (titlePrefix) {
titlePrefix.textContent = title ? `${title} - ` : '';
titlePrefix.hidden = !title;
}
if (skuElement) skuElement.textContent = sku;
if (skuWrap) skuWrap.hidden = !sku;
};
const updateVariantPrice = (card, variant = null) => {
const priceElements = card.querySelectorAll('.js-variant-card-price');
if (!priceElements.length) return;
priceElements.forEach((priceElement) => {
if (!priceElement._variantCardInitialState) {
priceElement._variantCardInitialState = {
className: priceElement.className,
innerHTML: priceElement.innerHTML
};
}
if (!variant) {
priceElement.className = priceElement._variantCardInitialState.className;
priceElement.innerHTML = priceElement._variantCardInitialState.innerHTML;
return;
}
const currentValue = priceElement.querySelector('.price__current .js-value');
const compareValue = priceElement.querySelector('.price__was .js-value');
const currentLabel = priceElement.querySelector('.price__current .js-label');
const compareLabel = priceElement.querySelector('.price__was .js-label');
const fromLabel = priceElement.querySelector('.price__from');
const unitPrice = priceElement.querySelector('.unit-price');
const unitPriceValue = unitPrice?.querySelector('span:not(.visually-hidden)');
const compareAtPriceHtml = String(variant.compare_at_price_html || '').trim();
const isOnSale = compareAtPriceHtml !== '';
if (currentValue && variant.price_html) currentValue.innerHTML = variant.price_html;
if (compareValue) compareValue.innerHTML = compareAtPriceHtml;
if (fromLabel) fromLabel.hidden = true;
priceElement.classList.toggle('price--on-sale', isOnSale);
priceElement.classList.toggle('price--sold-out', !variant.available);
if (currentLabel) {
currentLabel.textContent = isOnSale
? (window.theme?.strings?.salePrice || currentLabel.textContent)
: (window.theme?.strings?.regularPrice || currentLabel.textContent);
}
if (compareLabel) {
compareLabel.textContent = isOnSale
? (window.theme?.strings?.regularPrice || compareLabel.textContent)
: '';
}
if (unitPrice) {
const hasUnitPrice = Boolean(variant.has_unit_price && variant.unit_price_html);
unitPrice.hidden = !hasUnitPrice;
if (hasUnitPrice && unitPriceValue) unitPriceValue.innerHTML = variant.unit_price_html;
}
});
};
const syncQuantityControls = (form) => {
if (!form) return;
const input = form.querySelector('.js-variant-card-quantity-input');
if (!input) return;
const min = Math.max(1, Number.parseInt(input.min || '1', 10) || 1);
let value = Number.parseInt(input.value, 10);
if (!Number.isFinite(value) || value < min) value = min;
input.value = value;
const decreaseButton = form.querySelector('[data-quantity-action="decrease"]');
if (decreaseButton) decreaseButton.disabled = value <= min;
};
const showChooseOptions = (card) => {
const form = card.querySelector('.js-variant-card-form');
if (!form) return;
const idInput = form.querySelector('.js-variant-card-id');
const chooseLink = form.querySelector('.js-variant-card-choose');
const addButton = form.querySelector('.js-variant-card-atc');
const purchaseRow = form.querySelector('.js-variant-card-purchase-row');
const quantity = form.querySelector('.js-variant-card-quantity');
const stockMessage = form.querySelector('.js-variant-card-stock-message');
if (idInput) idInput.value = '';
updateVariantSelectionDisplay(form);
if (purchaseRow) purchaseRow.classList.remove('is-out-of-stock');
if (chooseLink) chooseLink.hidden = false;
if (addButton) { addButton.hidden = true; addButton.disabled = true; }
if (purchaseRow) purchaseRow.hidden = true;
if (quantity) quantity.hidden = true;
if (stockMessage) {
stockMessage.hidden = true;
stockMessage.textContent = '';
}
const variants = getVariantList(card);
if (variants.length && variants.every((variant) => !variant.available)) {
if (chooseLink) chooseLink.hidden = true;
if (purchaseRow) {
purchaseRow.hidden = false;
purchaseRow.classList.add('is-out-of-stock');
}
}
};
const getRepresentativeVariant = (card, clickedElement = null) => {
const optionElement = getOptionElement(clickedElement) || card.querySelector(
'.js-variant-card-option-value[data-selected="true"]'
);
const variantControl = optionElement?.matches?.('[data-variant-id]')
? optionElement
: optionElement?.querySelector?.('[data-variant-id]');
const variantId = variantControl?.dataset?.variantId;
return variantId ? getVariantData(card).get(String(variantId)) || null : null;
};
const updateCardInventory = (card, variant) => {
const notice = card.querySelector('.js-variant-card-inventory');
if (!notice) return;
notice.hidden = !variant;
if (!variant) return;
notice.dataset.inventoryLevel = variant.available ? 'in_stock' : 'none';
notice.textContent = variant.available ? theme.strings.inStock : theme.strings.noStock;
};
const updateCardState = (card, clickedElement = null) => {
const form = card.querySelector('.js-variant-card-form');
const variant = getSelectedVariant(card);
const representativeVariant = variant || getRepresentativeVariant(card, clickedElement);
updateCardInventory(card, variant);
updateOptionAvailability(card);
// Use the exact Size × Color match when available. If a card's
// native swatch finishes updating after the click event, retain its
// representative variant instead of leaving a stale price on screen.
updateVariantPrice(card, variant || representativeVariant);
// Collection-wide color buttons still update card media and product
// links when Quick Add (and therefore its product form) is disabled.
if (!form) {
if (representativeVariant) {
updateVariantLinks(card, representativeVariant);
updateVariantImage(card, representativeVariant);
} else {
updateVariantImage(card, null);
}
return;
}
if (!variant) {
// A collection-specific color can be selected before the shopper picks
// a size. Show that color's media immediately even though the complete
// Shopify variant is not resolved yet.
if (representativeVariant) updateVariantLinks(card, representativeVariant);
updateVariantImage(card, representativeVariant);
showChooseOptions(card);
return;
}
const variantId = String(variant.id);
updateVariantLinks(card, variant);
updateVariantImage(card, variant);
const idInput = form.querySelector('.js-variant-card-id');
const chooseLink = form.querySelector('.js-variant-card-choose');
const addButton = form.querySelector('.js-variant-card-atc');
const purchaseRow = form.querySelector('.js-variant-card-purchase-row');
const quantity = form.querySelector('.js-variant-card-quantity');
const quantityInput = form.querySelector('.js-variant-card-quantity-input');
const stockMessage = form.querySelector('.js-variant-card-stock-message');
if (idInput) idInput.value = variantId;
updateVariantSelectionDisplay(form, variant);
if (chooseLink) chooseLink.hidden = true;
if (purchaseRow) {
purchaseRow.hidden = false;
purchaseRow.classList.toggle('is-out-of-stock', !variant.available);
}
if (variant.available) {
if (addButton) {
addButton.hidden = false;
addButton.disabled = false;
addButton.removeAttribute('aria-disabled');
setButtonText(addButton, addButton.dataset.addToCartText || 'Add to cart');
}
if (quantity) quantity.hidden = false;
if (quantityInput && Number(quantityInput.value) < 1) quantityInput.value = 1;
syncQuantityControls(form);
if (stockMessage) {
stockMessage.hidden = true;
stockMessage.textContent = '';
}
} else {
if (addButton) {
addButton.hidden = true;
addButton.disabled = true;
}
if (quantity) quantity.hidden = true;
if (stockMessage) {
stockMessage.hidden = false;
stockMessage.textContent = variant.title && variant.title !== 'Default Title'
? `${variant.title}: out of stock`
: 'Out of stock';
}
}
};
const updateAfterTheme = (card, optionControl) => {
syncThemeSelectedOptions(card);
updateOptionAvailability(card);
updateCardState(card, optionControl);
card._lastValidOptions = new Map(getSelectedOptions(card));
window.requestAnimationFrame(() => {
syncThemeSelectedOptions(card);
updateOptionAvailability(card);
updateCardState(card, optionControl);
});
window.setTimeout(() => {
syncThemeSelectedOptions(card);
updateOptionAvailability(card);
updateCardState(card);
}, 80);
// Some collection cards use the theme's native swatch controls, which
// complete their selected state after the original click. Run one final
// reconciliation so price always reflects the settled Size × Color variant.
window.setTimeout(() => {
syncThemeSelectedOptions(card);
updateOptionAvailability(card);
const settledVariant = getSelectedVariant(card);
const settledRepresentative = settledVariant || getRepresentativeVariant(card, optionControl);
updateVariantPrice(card, settledRepresentative);
updateCardInventory(card, settledVariant);
}, 180);
};
document.addEventListener('click', (event) => {
const quantityButton = event.target.closest('.js-variant-card-quantity-button');
if (quantityButton) {
const form = quantityButton.closest('.js-variant-card-form');
const input = form?.querySelector('.js-variant-card-quantity-input');
if (!form || !input) return;
const min = Math.max(1, Number.parseInt(input.min || '1', 10) || 1);
const currentValue = Math.max(min, Number.parseInt(input.value, 10) || min);
const action = quantityButton.dataset.quantityAction;
input.value = action === 'decrease'
? Math.max(min, currentValue - 1)
: currentValue + 1;
syncQuantityControls(form);
input.dispatchEvent(new Event('change', { bubbles: true }));
return;
}
const sizeButton = event.target.closest('.js-variant-card-size-button');
if (sizeButton) {
const card = sizeButton.closest('product-card');
if (!card || sizeButton.disabled) return;
const optionElement = selectOptionElement(card, sizeButton);
if (optionElement) {
reconcileSelection(
card,
Number.parseInt(optionElement.dataset.optionPosition || '', 10),
optionElement.dataset.optionValue
);
}
updateAfterTheme(card, sizeButton);
return;
}
const swatch = event.target.closest(
'.card__swatches a, .card__swatches button, .card__swatches input, .card__swatches label'
);
if (!swatch) return;
const card = swatch.closest('product-card');
if (card) {
const optionElement = selectOptionElement(card, swatch) || swatch;
if (optionElement.dataset?.optionPosition) {
reconcileSelection(
card,
Number.parseInt(optionElement.dataset.optionPosition || '', 10),
optionElement.dataset.optionValue
);
}
updateAfterTheme(card, optionElement);
}
});
document.addEventListener('input', (event) => {
const quantityInput = event.target.closest('.js-variant-card-quantity-input');
if (!quantityInput) return;
syncQuantityControls(quantityInput.closest('.js-variant-card-form'));
});
document.addEventListener('change', (event) => {
const sizeSelect = event.target.closest('.js-variant-card-size-select');
if (sizeSelect) {
const card = sizeSelect.closest('product-card');
if (!card || !sizeSelect.value) return;
sizeSelect.dataset.optionValue = sizeSelect.value;
sizeSelect.dataset.selected = 'true';
const optionElement = selectOptionElement(card, sizeSelect) || sizeSelect;
reconcileSelection(
card,
Number.parseInt(optionElement.dataset.optionPosition || '', 10),
optionElement.dataset.optionValue
);
updateAfterTheme(card, optionElement);
return;
}
const quantityInput = event.target.closest('.js-variant-card-quantity-input');
if (quantityInput) {
syncQuantityControls(quantityInput.closest('.js-variant-card-form'));
return;
}
const swatchInput = event.target.closest('.card__swatches input, .card__swatches select');
if (!swatchInput) return;
const card = swatchInput.closest('product-card');
if (card) {
const optionElement = selectOptionElement(card, swatchInput) || swatchInput;
if (optionElement.dataset?.optionPosition) {
reconcileSelection(
card,
Number.parseInt(optionElement.dataset.optionPosition || '', 10),
optionElement.dataset.optionValue
);
}
updateAfterTheme(card, optionElement);
}
});
const initializeVariantCard = (card) => {
if (!card || card.dataset.variantCardInitialized === 'true') return;
if (!card.querySelector('.js-variant-card-data')) return;
selectInitialVariantOptions(card);
syncThemeSelectedOptions(card);
updateOptionAvailability(card);
preloadVariantImages(card);
const form = card.querySelector('.js-variant-card-form');
if (form) syncQuantityControls(form);
updateCardState(card);
card._lastValidOptions = new Map(getSelectedOptions(card));
card.dataset.variantCardInitialized = 'true';
};
const initializeVariantCardsWithin = (root) => {
if (!(root instanceof Element) && root !== document) return;
if (root instanceof Element) {
if (root.matches('product-card')) initializeVariantCard(root);
initializeVariantCard(root.closest('product-card'));
}
root.querySelectorAll?.('product-card').forEach(initializeVariantCard);
};
initializeVariantCardsWithin(document);
// Observe Ajax-rendered and theme-editor cards so every card receives its
// collection-color and image initialization.
const variantCardObserver = new MutationObserver((records) => {
records.forEach((record) => {
record.addedNodes.forEach((node) => initializeVariantCardsWithin(node));
});
});
variantCardObserver.observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('DOMContentLoaded', () => initializeVariantCardsWithin(document), { once: true });
document.addEventListener('on:facet-filters:updated', () => {
window.requestAnimationFrame(() => {
initializeVariantCardsWithin(document.getElementById('filter-results') || document);
});
});
document.addEventListener('submit', (event) => {
const form = event.target.closest('.js-variant-card-form');
if (!form) return;
syncQuantityControls(form);
const card = form.closest('product-card');
const variant = card && getSelectedVariant(card);
if (variant && !variant.available) {
event.preventDefault();
event.stopImmediatePropagation();
updateCardState(card);
return;
}
const idInput = form.querySelector('.js-variant-card-id');
if (card && !idInput?.value) updateCardState(card);
if (!idInput?.value) {
event.preventDefault();
const chooseLink = form.querySelector('.js-variant-card-choose');
if (chooseLink?.href) window.location.href = chooseLink.href;
}
}, true);
}






